import type { TrackerAdapter, PvOptions } from "../types";
import { PV_EVENT_NAME } from "../constants";
import { isBrowser } from "../utils";

/**
 * DataRangers (Volcengine) adapter.
 * Implements TrackerAdapter by delegating to window.collectEvent.
 */
export class DataRangersAdapter implements TrackerAdapter {
  /** 全局公共属性，每次上报自动合并 */
  private _globalProperties: Record<string, any> = {};

  private _getCollectEvent(): Function | undefined {
    if (!isBrowser()) return undefined;
    const fn = (window as any).collectEvent;
    if (typeof fn !== "function") {
      console.warn("[yl-nsm-track] window.collectEvent is not available");
      return undefined;
    }
    return fn;
  }

  getDefaultProps(): Record<string, any> {
    return {
      page_title: document.title || "",
      page_url: location.href,
      referrer: document.referrer || "",
      page_query: location.search || "",
    };
  }

  init(appId: number, options: Record<string, any>): void {
    const collectEvent = this._getCollectEvent();
    if (!collectEvent) return;

    // 提取并缓存全局属性，后续每次上报手动合并
    if (options.auto_track_properties) {
      this._globalProperties = { ...options.auto_track_properties };
    }

    collectEvent("init", {
      app_id: appId,
      disable_auto_pv: true,
      ...options,
    });
  }

  start(): void {
    const collectEvent = this._getCollectEvent();
    if (!collectEvent) return;

    collectEvent("start");
  }

  event(eventName: string, properties?: Record<string, any>): void {
    const collectEvent = this._getCollectEvent();
    if (!collectEvent) return;

    const props: Record<string, any> = {
      ...this.getDefaultProps(),
      ...this._globalProperties,
      ...(properties || {}),
    };
    collectEvent(eventName, props);
  }

  pageView(options?: PvOptions): void {
    const collectEvent = this._getCollectEvent();
    if (!collectEvent) return;

    const props: Record<string, any> = {
      ...this.getDefaultProps(),
      ...this._globalProperties,
      ...(options || {}),
    };

    collectEvent(PV_EVENT_NAME, props);
  }

  login(userId: string): void {
    const collectEvent = this._getCollectEvent();
    if (!collectEvent) return;

    collectEvent("config", { user_unique_id: userId });
  }

  logout(): void {
    const collectEvent = this._getCollectEvent();
    if (!collectEvent) return;

    collectEvent("config", { user_unique_id: null });
  }
}
